import { useEffect, useState } from "react";
import { portal } from "@/lib/api";
import { AvatarView } from "@/components/AvatarView";
import { ReadonlyProfile } from "@/components/ReadonlyProfile";
import { Users, ArrowLeft } from "lucide-react";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

export default function FamilyPortal() {
  const [classes, setClasses] = useState([]);
  const [classId, setClassId] = useState("");
  const [students, setStudents] = useState([]);
  const [student, setStudent] = useState(null);

  useEffect(() => { portal.classes().then(setClasses); }, []);
  useEffect(() => { if (classId) portal.classStudents(classId).then(setStudents); }, [classId]);

  const open = async (s) => setStudent(await portal.student(s.id));

  return (
    <div className="min-h-screen bg-background">
      <header className="h-16 border-b border-border flex items-center px-6 gap-2 bg-card">
        <div className="w-8 h-8 rounded-lg bg-secondary flex items-center justify-center text-secondary-foreground"><Users className="w-5 h-5" /></div>
        <span className="font-display font-extrabold">Cyberon <span className="text-secondary">Dojo</span> · Familias</span>
      </header>
      <main className="max-w-4xl mx-auto p-6 space-y-6">
        {!student ? (
          <>
            <h1 className="font-display text-3xl font-extrabold">Portal de familias</h1>
            <p className="text-muted-foreground text-sm">Consulta el progreso, los logros y la evolución del aprendizaje de tu hijo o hija.</p>
            <div className="grid sm:grid-cols-2 gap-3 max-w-xl">
              <Select value={classId} onValueChange={(v) => { setClassId(v); setStudents([]); }}>
                <SelectTrigger data-testid="family-class-select" className="rounded-xl"><SelectValue placeholder="Escuela / Clase" /></SelectTrigger>
                <SelectContent>{classes.map((c) => <SelectItem key={c.id} value={c.id}>{c.emoji} {c.name}</SelectItem>)}</SelectContent>
              </Select>
            </div>
            {classId && (
              <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-5 gap-4">
                {students.map((s) => (
                  <button key={s.id} data-testid={`family-pick-${s.id}`} onClick={() => open(s)} className="bg-card rounded-3xl border border-border p-4 flex flex-col items-center hover:-translate-y-1.5 hover:glow-primary transition-transform">
                    <AvatarView student={s} size={80} />
                    <div className="mt-3 font-bold text-sm text-center">{s.name}</div>
                  </button>
                ))}
                {students.length === 0 && <p className="text-sm text-muted-foreground col-span-full">Sin alumnos.</p>}
              </div>
            )}
          </>
        ) : (
          <>
            <button data-testid="family-back" onClick={() => setStudent(null)} className="flex items-center gap-1 text-sm font-semibold text-muted-foreground hover:text-foreground"><ArrowLeft className="w-4 h-4" /> Volver</button>
            <ReadonlyProfile student={student} />
          </>
        )}
      </main>
    </div>
  );
}
